import { ValueState } from "sap/ui/core/library";

export default {
  belegStatus: (value: string) => {
    if (!value) return "";

    let status = "";
    switch (value.toUpperCase()) {
      case "A":
        status = "A - angelegt";
        break;
      case "B":
        status = "B - in Bearbeitung";
        break;
      case "F":
        status = "F - fertig";
        break;
      case "G":
        status = "G - geprüft";
        break;
      case "K":
        status = "K - Kontrolle";
        break;
      case "R":
        status = "R - Restmenge/teilabgerufen";
        break;
      case "S":
        status = "S - Schlussbearbeitet";
        break;
      default:
        status = "unbekannt";
        break;
    }
    return status;
  },

  belegStatusState: (value: string) => {
    if (!value) return ValueState.None;

    let state = ValueState.None;

    switch (value.toUpperCase()) {
      case "A":
      case "R":
      case "B":
        state = ValueState.Information;
        break;
      case "K":
        state = ValueState.Warning;
        break;
      case "F":
      case "G":
      case "S":
        state = ValueState.Success;
        break;
      default:
        state = ValueState.Error;
        break;
    }
    return state;
  },

  druckStatus: (value: string) => {
    if (!value) return "";

    let status = "";
    switch (value.toUpperCase()) {
      case "N":
        status = "N - Nicht gedruckt";
        break;
      case "D":
        status = "D - gedruckt";
        break;
      case "T":
        status = "T - Tagesabschluss";
        break;
      case "G":
        status = "G - Garantie";
        break;
      default:
        status = "unbekannt";
        break;
    }
    return status;
  },

  druckStatusState: (value: string) => {
    if (!value) return ValueState.None;

    let state = ValueState.None;

    switch (value.toUpperCase()) {
      case "N":
        state = ValueState.Information;
        break;
      case "G":
        state = ValueState.Warning;
        break;
      case "D":
      case "T":
        state = ValueState.Success;
        break;
      default:
        state = ValueState.Error;
        break;
    }
    return state;
  },

  artikelNummer: (bereich: number, warengruppe: number, artikelgruppe: number, artikelnummer: number) => {
    return `
    ${String(bereich).padStart(2, "0")}
    ${String(warengruppe).padStart(2, "0")}
    ${String(artikelgruppe).padStart(2, "0")}
    ${String(artikelnummer).padStart(4, "0")}`;
  },

  percent: (number: string) => {
    return number + " %";
  },

  spanneValueState: (spanne: number) => {
    if (spanne >= 10) {
      return ValueState.Success;
    } else if (spanne >= 0) {
      return ValueState.Warning;
    } else {
      return ValueState.Error;
    }
  },

  emptyValue: (value: string, emptyValue: string) => {
    if (!value || !value.trim()) return emptyValue;
    else return value;
  },

  concatEmptyValue: (...params: string[]) => {
    const values = params.slice(0, -1);
    let nonEmptyValues = values.filter((v) => !!v);
    const sReturn = nonEmptyValues.join(" ").trim();

    if (sReturn) return sReturn;
    else return params[params.length - 1];
  },

  bestandObjectAttribute: (key: string, value: string, seperator: string, unit: string) => {
    return `${key}${seperator} ${value} ${unit}`;
  },

  kontaktDisplayName: (anrede: string, titel: string, vorname: string, nachname: string) => {
    return `${(anrede ?? "").trim()} ${(titel ?? "").trim()} ${(vorname ?? "").trim()} ${(nachname ?? "").trim()}`.trim();
  },

  formatHaus: (hausNo: number, hausName: string) => {
    return (hausNo ? "(" + hausNo + ") " : "") + (hausName ? hausName : "").trim();
  },

  firmaVorname: (firma: string, vorname: string) => {
    const trimmedFirma = (firma ?? "").trim();
    const trimmedVorname = (vorname ?? "").trim();

    if (trimmedFirma && trimmedVorname) {
      return `${trimmedFirma} (${trimmedVorname})`;
    } else if (trimmedFirma) {
      return trimmedFirma;
    } else if (trimmedVorname) {
      return trimmedVorname;
    } else {
      return "";
    }
  },
};
